var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',{staticClass:"priority-tag"},[_c('i',{class:_vm.symbol},_vm._l((_vm.max),function(bullet){return _c('em',{class:{ on: _vm.colorize(bullet) }},[_vm._v("•")])}),0),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.tag))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a3fab85","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Payment/components/PaymentPriorityTag.vue
// module id = dECR
// module chunks = 12